export default class Search {
  constructor() {
    this.search = document.querySelector(".jsSearch");
    this.searchPanel = document.querySelector(".jsSearchPanel");
    this.init();
  }

  toggle(i) {
    this.searchPanel.classList.contains("opened")
      ? this.searchPanel.classList.remove("opened")
      : this.searchPanel.classList.add("opened");
  }

  init() {
    this.search.addEventListener("click", () => {
      this.toggle();
    });
  }
}
